/**
 * Deprecated Module Multi-Select
 */

import {needJquery, extend} from '../../../../../shared/utils/index';
import SelectorEngine from "../../../../../shared/dom/selector-engine";
import Manipulator from "../../../../../shared/dom/manipulator";
import EventHandler from "../../../../../shared/dom/event-handler";
import Data from "../../../../../shared/dom/data";
import {initTooltips} from "../../../../vendors/bootstrap/bootstrap";

// -------
// Private
// -------

const $   = needJquery();

const DEFAULTS = {
	selectableHeader: `<input type="text" class="form-control search-input search-selectable" autocomplete="off" placeholder="Auswahl filtern"/>`,
	selectionHeader : `<input type="text" class="form-control search-input search-selection" autocomplete="off" placeholder="Auswahl filtern"/>`,
	keepOrder       : true
};

// -------
// Public
// -------

class MultipleSelect {
	constructor($element, o = {}) {
		this._element = $element[0];
		this._decoy = this._buildDecoy();
		this.maxItems = o.maxItems ?? false;
		this.controls = {
			pullLeft : null,
			pullRight: null
		};
		this.tpls = {
			selectableFooter: Manipulator.createElementFrom(`<footer class="ms-selectable__footer"/>`),
			selectionFooter : Manipulator.createElementFrom(`<footer class="ms-selection__footer"/>`),
			counterBadge    : this.maxItems ? Manipulator.createElementFrom(`<span class="badge ms-counter"/>`) : null
		};
		this.selectionOrder = [];

		const that = this; // not perfect, but works with old jquery library

		this._pendingState(true);

		this._buildTplsBeforeInit();

		this._api = $(this._decoy).multiSelect(extend({}, DEFAULTS, o, {
			selectionFooter : that.tpls.selectionFooter,
			selectableFooter: that.tpls.selectableFooter,
			afterInit       : function(element) {
				let initialSelected = null;

				that._buildSelectionButtons(element);
				that._initQuickSearch(this);

				// we have to wait because initialization is not ready -> bug
				setTimeout(() => {
					that.tpls.container           = this.$container[0];
					that.tpls.selectionContainer  = this.$selectionContainer[0];
					that.tpls.selectableContainer = this.$selectableContainer[0];

					that.countSelections();

					if(o.customEvents.afterInit && typeof o.customEvents.afterInit === 'function') {
						o.customEvents.afterInit(that);
					}

					initTooltips(that.tpls.container);

					initialSelected = Array.from(that._decoy.options)
						.filter(o => o.selected)
						.map(o => o.value);

					that.selectionOrder = initialSelected;
					that._syncOrder();

					that._pendingState(false);
				}, 500);
			},
			afterSelect: function(values) {
				this.qs1.cache();
				this.qs2.cache();
				that.countSelections();

				values.forEach(value => {
					if (!that.selectionOrder.includes(value)) {
						that.selectionOrder.push(value);
					}
				});

				that._syncOrder();

				if(o.customEvents.afterSelect && typeof o.customEvents.afterSelect === 'function') {
					o.customEvents.afterSelect(that);
				}
			},
			afterDeselect: function(values) {
				this.qs1.cache();
				this.qs2.cache();
				that.countSelections();

				values.forEach(value => {
					const index = that.selectionOrder.indexOf(value);
					if (index > -1) that.selectionOrder.splice(index, 1);
				});

				that._syncOrder();

				if(o.customEvents.afterDeselect && typeof o.customEvents.afterDeselect === 'function') {
					o.customEvents.afterDeselect(that);
				}
			}
		}));

		return this;
	}

	_pendingState(state) {
		if(state) {
			Data.set(this._decoy, 'pending', true);
			Manipulator.addClass(this._decoy, '-pending');
		} else {
			Data.set(this._decoy, 'pending', false);
			Manipulator.removeClass(this._decoy, '-pending');
		}
	}

	// create select copy with same name for correct
	_buildDecoy() {
		const clone = this._element.cloneNode(true);

		this._element.setAttribute('hidden', 'true');
		this._element.removeAttribute('id');
		this._element.removeAttribute('class');

		clone.removeAttribute('name');
		this._element.before(clone);

		return clone;
	}

	_syncOrder() {
		this._element.innerHTML = '';
		this.selectionOrder.forEach(value => {
			const option = document.createElement('option');
			option.value = value;
			option.selected = true;
			this._element.append(option);
		});
	}

	_buildTplsBeforeInit() {
		// Counter Badge
		if(this.tpls.counterBadge) {
			Manipulator.elementAppend(this.tpls.counterBadge, this.tpls.selectionFooter);
		}
	}

	_buildSelectionButtons(element) {
		this.controls.pullLeft  = Manipulator.createElementFrom(`<button title="alle abwählen" data-bind="tooltip" type="button" class="button deselect-all -default -s -square"><span class="button__label"><i class="fa-regular fa-chevron-double-left"></i></span></button>`);
		this.controls.pullRight = Manipulator.createElementFrom(`<button title="alle auswählen" data-bind="tooltip" type="button" class="button select-all -default -s -square"><span class="button__label"><i class="fa-regular fa-chevron-double-right"></i></span></button>`);
		const CONTROLS          = Manipulator.createElementFrom(`<div class="ms-controls"/>`);

		// add event handlers for buttons
		EventHandler.on(this.controls.pullRight, 'click', () => {
			event.preventDefault();
			this.selectAll();
		});

		EventHandler.on(this.controls.pullLeft, 'click', (event) => {
			event.preventDefault();
			this.deSelectAll();
		});

		// append elements to multiselect
		Manipulator.elementAppend(this.controls.pullLeft, CONTROLS);
		Manipulator.elementAppend(this.controls.pullRight, CONTROLS);
		Manipulator.elementAppend(CONTROLS, element);
	}

	// initialise quick search (third party)
	_initQuickSearch(qsApi) {
		let $selectableSearch      = qsApi.$selectableUl.prev(),
			$selectionSearch       = qsApi.$selectionUl.prev(),
			selectableSearchString = `#${qsApi.$container.attr('id')} .ms-elem-selectable:not(.ms-selected)`,
			selectionSearchString  = `#${qsApi.$container.attr('id')} .ms-elem-selection.ms-selected`;

		this.tpls.selectableHeader = qsApi.$selectableUl;
		this.tpls.selectionHeader = qsApi.$selectionUl;

		qsApi.qs1 = $selectableSearch.quicksearch(selectableSearchString).on('keydown', function(e) {
			if (e.which === 40) {
				qsApi.$selectableUl.focus();
				return false;
			}
		});

		qsApi.qs2 = $selectionSearch.quicksearch(selectionSearchString).on('keydown', function(e) {
			if (e.which == 40) {
				qsApi.$selectionUl.focus();
				return false;
			}
		});
	}

	countSelections() {
		const SELECTABLES = SelectorEngine.find('.ms-elem-selectable:not(.disabled):not(.ms-selected)', this.tpls.selectableContainer);
		const SELECTIONS = SelectorEngine.find('.ms-elem-selection.ms-selected', this.tpls.selectionContainer);

		this._api.selectableCounter = SELECTABLES.length ?? SELECTABLES.length;
		this._api.selectionCounter = SELECTIONS.length ?? SELECTIONS.length;

		if(this.maxItems) {
			this.tpls.counterBadge.innerHTML = `${this._api.selectionCounter} / ${this.maxItems}`;

			if(this._api.selectionCounter >= this.maxItems) {
				Manipulator.addClass(this.tpls.container, '_full');
			} else {
				Manipulator.removeClass(this.tpls.container, '_full');
			}

			// Check if count of possible selectables bigger than max possible selections
			if(this._api.selectableCounter > this.maxItems - this._api.selectionCounter) {
				Manipulator.addClass(this.controls.pullRight, '-disabled');
			} else {
				Manipulator.removeClass(this.controls.pullRight, '-disabled');
			}
		}
	}

	selectAll() {
		this._api.multiSelect('select_all');
	}

	deSelectAll() {
		this._api.multiSelect('deselect_all');
	}

	refresh() {
		this._api.multiSelect('refresh');
	}
}

const init = () => {
	const $collection = $('.multiSelect');

	if($collection.length) {
		$collection.each(function() {
			let multiSelectApi = new MultipleSelect($(this));
		});
	}
};

// Export
export default MultipleSelect;

export {
	init
};